import { useCallback, useEffect, useState } from 'react';

import { client, useErrorNotifications } from 'core/http';
import { Axle } from 'core/types/axle';

export default function useVehicleAxles(id: number) {
  const showErrorNotification = useErrorNotifications();
  const [axles, setAxles] = useState<Axle[]>([]);
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    if (!id) return;

    client()
      .get(`vehicles/${id}/axles`)
      .then(response => response.data)
      .then(setAxles)
      .catch(showErrorNotification);
  }, [id, showErrorNotification]);

  const remove = (index: number) => setAxles(axles.slice(0, index));

  const create = useCallback(() => {
    if (creating) return false;

    setCreating(true);

    return client()
      .post<Axle>(`vehicles/${id}/axles`)
      .then(response => response.data)
      .then(data => {
        // Initialize slots as empty
        const axle: Axle = { ...data, slots: [] };

        setAxles(axles => axles.concat(axle));
      })
      .catch(showErrorNotification)
      .finally(() => setCreating(false));
  }, [creating, id, showErrorNotification]);

  return { axles, create, creating, remove };
}
